import { AiChatButton as e } from "./components/ai-chat-button.mjs";
import { useWidgetControls as t } from "./hooks/use-widget-controlts.mjs";
import { Activity as n, Suspense as r, lazy as i, useState as a } from "react";
import { Fragment as o, jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/modules/widget/ai-chat-widget-host.tsx
var l = i(() => import("./ai-chat-widget.mjs").then((e) => ({ default: e.AiChatWidget })));
function u(i) {
	let { open: u, setOpen: d } = t(), [f, p] = a(u), [m, h] = a(u);
	return u && !f && p(!0), u && !m && h(!0), /* @__PURE__ */ c(o, { children: [/* @__PURE__ */ s(e, { onClick: () => d((e) => !e) }), f && /* @__PURE__ */ s(n, {
		mode: m ? "visible" : "hidden",
		children: /* @__PURE__ */ s(r, {
			fallback: null,
			children: /* @__PURE__ */ s(l, {
				...i,
				onClose: () => d(!1),
				onCloseAnimationEnd: () => h(!1)
			})
		})
	})] });
}
//#endregion
export { u as AiChatWidgetHost };
